export const SET_LICENSES = "SETTINGS_SET_LICENSES";
export const SET_ERROR = "SETTINGS_SET_ERROR";
export const TOGGLE_LOADING = "SETTINGS_TOGGLE_LOADING";
